import React, { useCallback, useEffect, useState } from 'react';
import '../css/Home.css';
import Swal from 'sweetalert';
import { lerComunicados, enviarComunicado, excluirComunicado } from '../firebase/comunicados';
import { lerEvento } from '../firebase/evento';
import { verificarNotificacaoResponsavel, verificarNotificacaoServidor} from '../firebase/notificacao';
import { Link } from 'react-router-dom';
import { db, ANO } from '../firebase/notificacao';


// ICONES
import { IonIcon } from '@ionic/react';
import { link, wifiOutline, batteryFullOutline, cellularOutline, schoolOutline, notificationsOutline, homeOutline, chatbubbleEllipsesOutline, calendarOutline, personOutline, addCircleOutline, trashOutline } from 'ionicons/icons';


const Home = () => {
  
  const root = document.documentElement;
  const imagemHome = root.style.getPropertyValue('--imagem');
  
  // COMUNICADOS E EVENTOS
  const comunicadoLista = localStorage.getItem('comunicados');
  const comunicados = comunicadoLista ? JSON.parse(comunicadoLista) : [];
  const [eventos, setEventos] = useState([]);
  
  // DADOS
  const storedResponsavel = localStorage.getItem('responsavel');
  const storedSerie = localStorage.getItem('serie');
  const storedLogado = localStorage.getItem('logado');
  const storedUsuario = localStorage.getItem('usuario');
  const [responsavel, setResponsavel] = useState(storedResponsavel ? storedResponsavel : null);
  const [serie, setSerie] = useState(storedSerie ? storedSerie : null);
  const [logado, setLogado] = useState(storedLogado ? storedLogado.toLowerCase() : null);
  const [usuario, setUsuario] = useState(storedUsuario ? storedUsuario : null);

  
  if (!logado) {
    localStorage.clear();
    window.location.href = "../logar";
  }
  
  // RELOGIO
  const [horaAtual, setHoraAtual] = useState(new Date());
  useEffect(() => {
    
    const intervalId = setInterval(() => {
      setHoraAtual(new Date());
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);
  const formatDigit = (digit) => (digit < 10 ? '0' + digit : digit);
  const horas = formatDigit(horaAtual.getHours());
  const minutos = formatDigit(horaAtual.getMinutes());
  const segundos = formatDigit(horaAtual.getSeconds());


  // STATUS NOTIFICAÇÃO
  const [statusNotificacao, setStatusNotificacao] = useState(true);
  
  // PAGINA
  const [mostrarFormComunicado, setMostrarFormComunicado] = useState(false);
  const [resultadoFile, setResultadoFile] = useState("");
  
  const statusNotificacaoResponsavel = useCallback( async () => {
    try {
      const resposta = await verificarNotificacaoResponsavel(responsavel, serie);
      setStatusNotificacao(resposta);
    } catch (error) {
      console.log(error);
    }
    
  }, [statusNotificacao]);

  const statusNotificacaoServidor = useCallback( async () => {
    try {
      const resposta = await verificarNotificacaoServidor(logado, usuario);
      setStatusNotificacao(resposta);
    } catch (error) {
      console.log(error);
    } 
    
  }, [statusNotificacao]);

  useEffect(() => {
    if (logado === 'responsavel') {
      statusNotificacaoResponsavel();
    } else {
      statusNotificacaoServidor();
    }
  }, []);

  const handleResultadoFile = (event) => {
    const arquivo = event.target.files[0];

    // Verifica se um arquivo foi selecionado
    if (arquivo) {
      setResultadoFile(arquivo.name);
    } else {
      setResultadoFile('');
    }
  }

  const handleSetImagem = (e) => {
    // Obtém o arquivo a partir do evento
    const arquivo = e.target.files[0];
    console.log(arquivo)
    // Atualiza o estado com o arquivo
    setImagem(arquivo);

    // Aqui, você pode realizar outras operações com o arquivo, se necessário
  };

  // INPUTS
  const [imagem, setImagem] = useState(null);
  const [titulo, setTitulo] = useState('');
  const [mensagem, setMensagem] = useState('');


  const avisos = JSON.parse(localStorage.getItem('avisos')) || [];
  const naoLerAvisos = JSON.parse(localStorage.getItem('naoLerAvisos')) || [];
  const mostrarAvisos = async (avisos, naoLerAvisos) => {
    try {
      for (const aviso of avisos) {
        const { titulo, mensagem, html, uid } = aviso;
        
        let ignorarAviso = false;

        // Verifica se o uid já está na lista naoLerAvisos
        for (const id of naoLerAvisos) {
          if (id === uid) {
              ignorarAviso = true; // Define a flag para true e sai do loop
              break;
          }
        }

        if (ignorarAviso) {
            continue; // Pula para a próxima iteração do loop
        }

        naoLerAvisos.map((id) => {
          if (id === uid) {
            return;
          }
        });

        const htmlContent = `
          <div style="color: var(--light)">
            <label>Ra e o Dígito</label>
            <input id="raDigitoBoletim" type="text" />
          
            <label>Data de Nascimento</label>
            <input id="nascimentoBoletim" type="text" />
            <button onclick="teste()">Salvar</button>
          </div>
        `;
  
        if (html) {
          await Swal({
            className: 'swal-aviso',
            title: titulo,
            text: mensagem,
            content: {
              element: "div",
              attributes: {
                innerHTML: html
              },
            },
            buttons: {
              confirm: 'Não mostrar mais',
              cancel: 'Ok',
            }
          }).then((response) => {
            if (response) {
              naoLerAvisos.push(uid.replace(/\s/g, ''));
              localStorage.setItem('naoLerAvisos', JSON.stringify(naoLerAvisos));
              return new Promise((resolve) => setTimeout(resolve, 1000)); // Atraso de 1 segundo
            }
          });
        } else {
          await Swal({
            className: 'swal-aviso',
            title: titulo,
            text: mensagem,
            buttons: {
              confirm: 'Não mostrar mais',
              cancel: 'Ok',
            }
          }).then((response) => {
            if (response) {
              naoLerAvisos.push(uid.replace(/\s/g, ''));
              localStorage.setItem('naoLerAvisos', JSON.stringify(naoLerAvisos));
              return new Promise((resolve) => setTimeout(resolve, 1000)); // Atraso de 1 segundo
            }
          });
        }
      }
    } catch (error) {
      console.error("Erro ao exibir avisos:", error);
    }
  }


    useEffect(() => {
      setTimeout(() => {
        if (logado) {
          mostrarAvisos(avisos, naoLerAvisos);
        }  
      }, 1000);
    }, []);


  const salvarDadosDoBoletim = async (uid) => {
    const ra = document.getElementById('raDigitoBoletim').value;
    const nascimento = document.getElementById('nascimentoBoletim').value;
    await db.collection(ANO)
    .doc('responsaveis')
    .collection(responsavel)
    .doc(responsavel)
    .update({
        ra: ra,
        nascimentoAluno: nascimento,
    }).then((res) => {
        naoLerAvisos.push(uid.replace(/\s/g, ''));
        localStorage.setItem('usuarioSed', ra);
        localStorage.setItem('nascimentoAluno', nascimento);
        localStorage.setItem('naoLerAvisos', JSON.stringify(naoLerAvisos));
        Swal({
          icon: 'success',
          title: 'Dados salvados com sucesso!',
        });
    });
  };

  const naoMostrarAviso = async (uid) => {
    await naoLerAvisos.push(uid.replace(/\s/g, ''));
    await localStorage.setItem('naoLerAvisos', JSON.stringify(naoLerAvisos));
  };

  const formatarNascimentoBoletim = (nascimento) => {
    const formattedNascimento = nascimento.replace(/\D/g, '');

    let formattedString = '';

    if (formattedNascimento.length <= 2) {
      formattedString = formattedNascimento;
    } else if (formattedNascimento.length <= 4) {
      formattedString = formattedNascimento.substring(0, 2) + '/' + formattedNascimento.substring(2);
    } else {
      formattedString = formattedNascimento.substring(0, 2) + '/' + formattedNascimento.substring(2, 4) + '/' + formattedNascimento.substring(4, 8);
    }

    document.getElementById('nascimentoBoletim').value = formattedString;
  }

  window.formatarNascimentoBoletim = formatarNascimentoBoletim;
  window.salvarDadosDoBoletim = salvarDadosDoBoletim;
  window.naoMostrarAviso = naoMostrarAviso;


  return (
    <main className="container-home">
      <div className="before">
        <p id="hora">
          {horas}:{minutos}:{segundos}
        </p>

        <div className="flex">
          <IonIcon icon={wifiOutline} />
          <IonIcon icon={cellularOutline} />
          <IonIcon icon={batteryFullOutline} />
        </div>
      </div>

      {!mostrarFormComunicado ? (

        <div className='width-100 margin-0'>
          {logado && usuario ? (
            <div>
              <header className="bem-vindo">

                  {imagemHome ? (
                    <img src={imagemHome}/>
                  ) : (
                    <IonIcon icon={schoolOutline} />
                  )}

                  <h1>Olá, {(logado === 'direcao') ? 'Direção' : (logado === 'coordenacao') ? 'Coordenação' : (logado === 'responsavel') ? 'Responsável' :(logado === 'responsavel') ? 'Responsável' : (logado === 'professor') ? 'Professor(a)' : logado} - {usuario}</h1>
                
                
                <h2><span>Bem-Vindo</span> ao aplicativo do <span>Ensino Médio</span> da Escola Estadual Profª Letícia de Godoy Bueno Carvalho Lopes</h2>
              </header>
            </div>
          ): logado && responsavel ? (
            <div>
              <header className="bem-vindo">

                {imagemHome ? (
                  <img src={imagemHome}/>
                ) : (
                  <IonIcon icon={schoolOutline} />
                )}
                <h1>Olá, responsável - {responsavel}</h1>
                <h2><span>Bem-Vindo</span> ao aplicativo do <span>Ensino Médio</span> da Escola Estadual Profª Letícia de Godoy Bueno Carvalho Lopes</h2>

              </header>
            </div>
          ) : (
            <div></div>
          )
        }

        {!statusNotificacao && (
          <div className="popup-notification">
            <img src={require('../img/pushNotification.png')} alt="Push Notificação"/>
            <h1>Quer receber Notificações?</h1>
            <p>Receba notificações para ficar atualizado sobre as últimas novidades e informações importantes.</p>
            <Link className="width-100" to="/app/perfil?pagina=notification">
              <button>Ver Tutorial</button>
            </Link>
          </div>
        )}

          <section className="guia">
            <h1>Guia rápido para utilização:</h1>
            <p>
              Este aplicativo visa facilitar o acompanhamento da vida escolar dos nossos estudantes. Confira abaixo as opções de ferramentas que seu acesso oferece. Todas elas podem ser facilmente selecionadas através dos atalhos presentes no menu de navegação logo abaixo.
            </p>
            <ul>
              <li>
                <IonIcon icon={homeOutline}/>
                <p><strong>Página Inícial: </strong>Navegue pelas funcionalidades e aproveite as novas ferramentas disponíveis. </p>
              </li>
              <li>  
                <IonIcon icon={notificationsOutline}/>
                <p><strong>Notificações: </strong> Eventos, comunicados e recados gerais. </p>
              </li>
              <li>
                <IonIcon icon={chatbubbleEllipsesOutline}/>
                <p><strong>Mensagens: </strong> Envio de Informações importantes e atendimento de dúvidas. </p>
              </li>
              <li>
                <IonIcon icon={calendarOutline}/>
                <p><strong>Mural: </strong> Boletim do aluno, data de Provas Internas e Externas.</p>
              </li>
              <li>
                <IonIcon icon={personOutline}/>
                <p><strong>Perfil: </strong> Modifique suas informações pessoais, senhas e encontre outras opções importantes. </p>
              </li>
            </ul>
          </section>

          {comunicados.length > 0 && (
            <div className="containerAviso">
              {comunicados.map((comunicado) => (
                <div className="card">
                  {comunicado.imagem && (
                    <img src={comunicado.imagem} />
                  )}
                  <h1>{comunicado.titulo}</h1>
                  <p dangerouslySetInnerHTML={{ __html: comunicado.mensagem }}></p>
                  {/*<p>{comunicado.mensagem}</p>*/}
                  {logado === 'direcao' || logado === 'coordenacao' ? (
                    <IonIcon onClick={() => excluirComunicado(comunicado.id, comunicado.nomeImagem)} className='excluir' icon={trashOutline} />
                  ) : (
                    <span></span>
                  )}
                </div>
              ))}
            </div>
          )}

          {!mostrarFormComunicado && logado === 'direcao' ||  logado === 'coordenacao' ? (
            <div className='btn-mostrarForm'>
              <IonIcon onClick={() => setMostrarFormComunicado(true)} icon={addCircleOutline} />
            </div>
          ) : (
            <div></div>
          )}

        </div>
      ) : (
        <div className='width-100'>
        {mostrarFormComunicado && (
          <div className="form-tecvit formComunicado">
  
            <h1>Enviar comunicado</h1>
            
            <div className='flex'>
              <div className='input-file-container'>
                <input onChange={(e) => {
                  handleResultadoFile(e);
                  handleSetImagem(e);
                }}
                className='input-file' type="file" name="imagem" />
                <label className='label-file'>Imagem</label>
              </div>
              <p className='resultado-file'>
                <strong>Nome:</strong> 
                {resultadoFile !== "" ? resultadoFile : 'Nenhum'}
              </p>
            </div>
  
            <div className='flex'>
              <input onChange={(e) => setTitulo(e.target.value)} type="text" placeholder=" " />
              <label>Título</label>
            </div>
  
            <div className='flex'>
              <textarea onChange={(e) => setMensagem(e.target.value)} placeholder=" "></textarea>
              <label>Mensagem</label>
            </div>
  
            <div className='flex'>
              <button onClick={() => enviarComunicado(imagem, titulo, mensagem)}>Enviar</button>
            </div>
  
            <div className='flex'>
              <button onClick={() => setMostrarFormComunicado(false)} className='fechar'>Fechar</button>
            </div>
  
          </div>
        )}
        </div>
      )}

      

    </main>
  );
};


export default Home;